import logo from './logo.svg';
// import './App.css';
import Login from './components/Staff/login';
import { BrowserRouter, Route, Routes, Redirect, Navigate, useNavigate } from 'react-router-dom';

import LoginWithOTP from './components/Staff/LoginWithOTP';
import LoginWithPhone from './components/Staff/LoginWIthPhone';
import MailSent from './components/Staff/MailSent';
import Accepted from './components/Staff/Accepted';
import Details from './components/Staff/Details';
import Pending from './components/Staff/Pending';
import StepOne from './components/Customer/StepOne';
import { Provider, useDispatch, useSelector } from 'react-redux';

import loading from './services/Loading.gif'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useCallback, useEffect, useState } from 'react';
import V2PRM from './components/Staff/V2PRM';
import UploadFC from './components/Staff/UploadFC';
import KYCComparison from './components/Staff/KYCComparison';
import ListRequests from './components/Staff/ListRequests';
import KYC from './components/Staff/KYC';
import RegLogin from './components/Customer/RegLogin';
import StepTwo from './components/Customer/StepTwo';
import StepThreeCin from './components/Customer/StepThreeCin';
import StepThreeCinDirectorList from './components/Customer/StepThreeCinDirectorList';
import StepThreeCinSkipped from './components/Customer/StepThreeCinSkipped';
import StepThreePartner from './components/Customer/StepThreePartner';
import StepThreeProperitor from './components/Customer/StepThreeProperitor';
import StepFour from './components/Customer/StepFour';
import StepFourDeclarationPartner from './components/Customer/StepFourDeclarationPartner';
import StepFourDeclarationProperitor from './components/Customer/StepFourDeclarationProperitor';
import StepFourUpload from './components/Customer/StepFourUpload';
import StepFive from './components/Customer/StepFive';
import Success from './components/Customer/Success';
import Loading from './components/Customer/Loading';
import SessionExpired from './components/Common/SessionExpired';
import { setCustomerAuthenticate } from './services/redux/CustomerAuthentication';
import { setDetailsData } from './services/redux/DetailsReducer';
import { setCustomerData } from './services/redux/CustomerDataReducer';
import { Authenticate } from './services/redux/AuthenticationReducer';
import { LoginUser } from './services/redux/LoginReducer';
import { setV2PRMData } from './services/redux/V2PRMReducer';
import { setPendingData } from './services/redux/PendingReducer';
import { setMailSentData } from './services/redux/MailSentReducer';
import { setAcceptedData } from './services/redux/AcceptedReducer';
import { setFiltersData } from './services/redux/FilterReducer';
import { setKycRequestData } from './services/redux/KYCRequestReducer';
import StepSeven from './components/Customer/StepSeven';
import StepSix from './components/Customer/StepSix';
import { setSuccessPage } from './services/redux/SuccessReducer';
import { setCustomerBankDetails } from './services/redux/CustomerBankDataReducer';

import { jwtDecode } from 'jwt-decode'; 

let deferredPrompt;

function App() {
  const isLoading = useSelector((state) => state.loading.isLoading);
  const isAuthenticated = useSelector((state) => state.authentication.isAuthenticated);
  const isCustomerAuthenticated = useSelector((state) => state.customerAuthenticate.isCustomerAuthenticated);

  const [installable, setInstallable] = useState(false);
  const isAndroid = /Android/.test(navigator.userAgent);
  const [isVisible, setIsVisible] = useState(true);

const loginState = useSelector((state) => state.login.loginData);
const customerData = useSelector((state) => state.customerData.customerData);

  useEffect(() => {
    window.addEventListener("beforeinstallprompt", (e) => {
      // Prevent the mini-infobar from appearing on mobile
      e.preventDefault();
      // Stash the event so it can be triggered later.
      deferredPrompt = e;
      // Update UI notify the user they can install the PWA
      setInstallable(true);
      setIsVisible(true);
    });

    window.addEventListener('appinstalled', () => {
      // Log install to analytics
      console.log('INSTALL: Success');
    });
  }, [isAuthenticated, isCustomerAuthenticated]);
  const handleInstallClick = (e) => {
    // Hide the app provided install promotion
    setInstallable(false);
    // Show the install prompt
    deferredPrompt.prompt();
    // Wait for the user to respond to the prompt
    deferredPrompt.userChoice.then((choiceResult) => {
      if (choiceResult.outcome === 'accepted') {
        console.log('User accepted the install prompt');
      } else {
        console.log('User dismissed the install prompt');
      }
    });
  };

  // State for elapsed time
  const [elapsedTime, setElapsedTime] = useState(0);
  const dispatch = useDispatch()
  const navigate = useNavigate()

  // useEffect(() => {
  //   let timer;
  //   const idleTimeout = isCustomerAuthenticated?900000:900; // 900 seconds of inactivity before logout

  //   const resetTimer = () => {
  //     clearInterval(timer);
  //     setElapsedTime(idleTimeout); // Set elapsed time to idleTimeout when reset
  //     timer = setInterval(() => {
  //       setElapsedTime(prevElapsedTime => {
  //         const newElapsedTime = prevElapsedTime - 1;
  //         if (newElapsedTime <= 0) {
  //           console.log("User has been logged out due to inactivity.");
  //           if (isCustomerAuthenticated) {
  //             dispatch(setCustomerAuthenticate(false));
  //             dispatch(setDetailsData(''));
  //             dispatch(setCustomerData(''));
  //             navigate('/Customer/SessionExpired', { state: { action: 'customerLogout' } })
  //           }
  //           if (isAuthenticated) {
  //             dispatch(Authenticate(false));
  //             dispatch(LoginUser(''))
  //             dispatch(setV2PRMData(''))
  //             dispatch(setPendingData(''))
  //             dispatch(setMailSentData(''))
  //             dispatch(setAcceptedData(''))
  //             dispatch(setDetailsData(''))
  //             dispatch(setFiltersData(''))
  //             dispatch(setCustomerData(''))
  //             dispatch(setKycRequestData(''))
  //           }
  //           if(isCustomerAuthenticated){
  //             dispatch(setSuccessPage(true));
  //             dispatch(setCustomerAuthenticate(false));
  //             dispatch(setDetailsData(''))
  //             dispatch(setCustomerData(''))
  //             dispatch(setCustomerBankDetails(null))
  //           }
  //           clearInterval(timer);
  //           // Perform logout actions here
  //           return 0; // Set elapsed time to 0 when the timer runs out
  //         }
  //         return newElapsedTime;
  //       });
  //     }, 1000);
  //   };

  //   const handleUserActivity = () => {
  //     console.log("User activity detected.");
  //     resetTimer();
  //   };

  //   resetTimer();

  //   // Event listeners for user activity
  //   window.addEventListener('mousemove', handleUserActivity);
  //   window.addEventListener('keydown', handleUserActivity);
  //   window.addEventListener('click', handleUserActivity);

  //   // Clear the timer and remove event listeners on component unmount
  //   return () => {
  //     clearInterval(timer);
  //     window.removeEventListener('mousemove', handleUserActivity);
  //     window.removeEventListener('keydown', handleUserActivity);
  //     window.removeEventListener('click', handleUserActivity);
  //   };
  // }, [dispatch, isCustomerAuthenticated, isAuthenticated]); // Adjust dependencies array as needed


  const handleLogout = () => {
    if (isAuthenticated) {
       localStorage.clear();
                  dispatch(Authenticate(false));
                  dispatch(LoginUser(''))
                  dispatch(setV2PRMData(''))
                  dispatch(setPendingData(''))
                  dispatch(setMailSentData(''))
                  dispatch(setAcceptedData(''))
                  dispatch(setDetailsData(''))
                  dispatch(setFiltersData(''))
                  dispatch(setCustomerData(''))
                  dispatch(setKycRequestData(''))
                  navigate('/');
                  return;
                }
                if(isCustomerAuthenticated){
                   localStorage.clear();
                  dispatch(setCustomerAuthenticate(false));
                  dispatch(setDetailsData(''))
                  dispatch(setCustomerData(''))
                  dispatch(setCustomerBankDetails(null))
                  navigate('/Customer/SessionExpired', { state: { action: 'customerLogout' } })
                  return;
                }
  };


// ADD THIS ENTIRE useEffect - Token Validation
useEffect(() => {
  const validateTokens = () => {
    try {
      // Validate staff authentication
      if (isAuthenticated) {
        const token = loginState?.token_chr;
        
        // If authenticated but no token, logout
        if (!token) {
          // console.log('Staff: Auth flag true but no token - logging out');
          handleLogout();
          return;
        }
        
        try {
          const decodedToken = jwtDecode(token);
          const currentTime = Date.now() / 1000;
          
          // Check if token expired
          if (decodedToken.exp < currentTime) {
            // console.log('Staff: Token expired - logging out');
            handleLogout();
          }
        } catch (error) {
          // console.log('Staff: Invalid token - logging out');
          handleLogout();
        }
      }

      // Validate customer authentication
      if (isCustomerAuthenticated) {
        const token = customerData?.token_chr;
        
        // If authenticated but no token, logout
        if (!token) {
          // console.log('Customer: Auth flag true but no token - logging out');
          dispatch(setCustomerAuthenticate(false));
          dispatch(setDetailsData(''));
          dispatch(setCustomerData(''));
          dispatch(setCustomerBankDetails(null));
          navigate('/Customer/SessionExpired', { state: { action: 'tokenExpired' } });
          return;
        }
        
        try {
          const decodedToken = jwtDecode(token);
          const currentTime = Date.now() / 1000;
          
          // Check if token expired
          if (decodedToken.exp < currentTime) {
            // console.log('Customer: Token expired - logging out');
            dispatch(setCustomerAuthenticate(false));
            dispatch(setDetailsData(''));
            dispatch(setCustomerData(''));
            dispatch(setCustomerBankDetails(null));
            navigate('/Customer/SessionExpired', { state: { action: 'tokenExpired' } });
          }
        } catch (error) {
          // console.log('Customer: Invalid token - logging out');
          dispatch(setCustomerAuthenticate(false));
          dispatch(setDetailsData(''));
          dispatch(setCustomerData(''));
          dispatch(setCustomerBankDetails(null));
          navigate('/Customer/SessionExpired', { state: { action: 'tokenExpired' } });
        }
      }
    } catch (error) {
      console.error('Token validation error:', error);
    }
  };

  // Run validation when auth state or tokens change
  validateTokens();
}, [isAuthenticated, isCustomerAuthenticated, loginState?.token_chr, customerData?.token_chr]);


  useEffect(() => {
    let idleTime = 0;
    const timeoutDuration = 900000;

    const events = ["load", "mousemove", "mousedown", "click", "keydown", "scroll", "keypress"];
    const resetIdleTime = () => {
      idleTime = 0;
      // console.log("Activity detected. Resetting idle time.");
    };

    const checkIdleTimeout = () => {
      idleTime += 1000;
      // console.log(`Idle time: ${idleTime / 1000} seconds`);
      if (idleTime >= timeoutDuration) {
        handleLogout();
      }
    };

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        // console.log("Escape key pressed");
        resetIdleTime()
      }
    };

    events.forEach((event) => {
      window.addEventListener(event, resetIdleTime);
    });

    window.addEventListener("keydown", handleKeyDown);

    const timer = setInterval(checkIdleTimeout, 1000);

    return () => {
      events.forEach((event) => {
        window.removeEventListener(event, resetIdleTime);
      });
      window.removeEventListener("keydown", handleKeyDown);
      clearInterval(timer);
    };
  }, [dispatch, navigate]);

  return (
    <>
      {isAndroid && isVisible && installable &&
        <div
          style={{
            position: 'fixed',
            top: '5%',
            left: '47%',
            transform: 'translate(-50%, -50%)',
            zIndex: '1000',
            padding: '10px',
            width: '90%',
            borderRadius: '10px',
            margin: '5px 5px',
            background: '#2e61a2',
            visibility: isVisible ? 'visible' : 'hidden',
            opacity: isVisible ? '1' : '0',
            transition: 'opacity 0.5s ease-in-out, visibility 0.5s ease-in-out',
            display: 'flex',
            justifyContent: 'space-between',
          }}>
          <p style={{ color: 'white', marginTop: '5px' }}>
            Install our app to your home sreen
          </p>
          {/* <button className="border-0" style={{ backgroundColor: 'white', borderRadius: '10px', padding: '10px' }} onClick={handleInstallClick}> */}
          <svg onClick={() => handleInstallClick()} xmlns="http://www.w3.org/2000/svg" style={{ color: 'white', marginTop: "5px" }} width="20" height="20" fill="currentColor" class="bi bi-download" viewBox="0 0 16 16">
            <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
            <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z" />
          </svg>
          {/* </button> */}
          {/* <button className="border-0" style={{ backgroundColor: 'white', borderRadius: '10px', padding: '10px' }} onClick={() => setIsVisible(false)}> */}
          <svg onClick={() => setIsVisible(false)} xmlns="http://www.w3.org/2000/svg" style={{ color: 'white', marginTop: "5px" }} width="20" height="20" fill="currentColor" class="bi bi-x-circle" viewBox="0 0 16 16">
            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
          </svg>
          {/* </button> */}
        </div>

      }
      {isCustomerAuthenticated && (
        <p className='hidden'>Elapsed Time: {elapsedTime} seconds</p>
      )}
      {isAuthenticated && (
        <p className='hidden'>Elapsed Time: {elapsedTime} seconds</p>
      )}
      <Routes>
        {!isAuthenticated ? (
          <>
            {isCustomerAuthenticated ? (
              <>
                <Route path="/" element={<StepOne />} />
                <Route path="/Customer/Step2" element={<StepTwo />} />
                <Route path="/Customer/Step3Cin" element={<StepThreeCin />} />
                <Route path="/Customer/Step3CinDirectorList" element={<StepThreeCinDirectorList />} />
                <Route path="/Customer/Step3CinSkipped" element={<StepThreeCinSkipped />} />
                <Route path="/Customer/Step3Partner" element={<StepThreePartner />} />
                <Route path="/Customer/Step3Properitor" element={<StepThreeProperitor />} />
                <Route path="/Customer/Step4" element={<StepFour />} />
                <Route path="/Customer/Step4DeclarationPartner" element={<StepFourDeclarationPartner />} />
                <Route path="/Customer/Step4DeclarationProperitor" element={<StepFourDeclarationProperitor />} />
                <Route path="/Customer/Step4Upload" element={<StepFourUpload />} />
                <Route path="/Customer/Step7" element={<StepSeven />} />
                <Route path="/Customer/Step6" element={<StepSix />} />
                <Route path="/Customer/Step5" element={<StepFive />} />
              </>
            ) : <>
              <Route path="/" element={<Login />} />
              <Route path="/otp" element={<LoginWithOTP />} />
              <Route path="/login/Mobile" element={<LoginWithPhone />} />
              <Route path="/Customer/Login" element={<RegLogin />} />
              <Route path="/self-onboarding/login/:token" exact element={<Loading />} />
              <Route path="/Customer/Success" element={<Success />} />
              <Route path="/Customer/SessionExpired" element={<SessionExpired />} />
            </>}
          </>
        ) : (
          <>
            <Route path="/mailSent" element={<MailSent />} />
            <Route path="/accepted" element={<Accepted />} />
            <Route path="/details" element={<Details />} />
            <Route path="/V2PRM" element={<V2PRM />} />
            <Route path="/UploadFile" element={<UploadFC />} />
            <Route path="/KYC" element={<KYC />} />
            <Route path="/KYCComparison" element={<KYCComparison />} />
            <Route path="/ListRequests" element={<ListRequests />} />
            <Route path="/pending" element={<Pending />} />
          </>
        )}

        {/* Add a default route to handle unknown routes */}
        <Route
          path="*"
          element={
            isAuthenticated ? <Navigate to="/mailSent" /> : <Navigate to="/" />
          }
        />
      </Routes>
      <ToastContainer />
      {
        isLoading ? (
          <div
            style={{
              width: '100%',
              height: '100%',
              position: 'fixed',
              top: 0,
              left: 0,
              zIndex: 9999999,
              background: 'rgba(0, 0, 0, 0.6)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <div>
              <img src={loading} alt="" />
            </div>
          </div>
        ) : null
      }
    </>
  );
}

export default App;
